import { useRef } from 'react'
import { BROADCAST_MESSAGE_TYPES } from 'utils/broadcastChannel'
import { useBroadcastMessage } from 'utils/hooks/useBroadcastMessage'
import { useAuth } from './useAuth'
import { useAuthState } from './useAuthState'

export const useEmailConfirmedBroadcast = () => {
  const { tryStartSession } = useAuth()
  const { isAuthenticated, user } = useAuthState()
  const userRef = useRef(user)

  userRef.current = user

  useBroadcastMessage(
    BROADCAST_MESSAGE_TYPES.EMAIL_CONFIRMED,
    () => {
      if (userRef.current?.is_email_confirmed === true) {
        return
      }

      tryStartSession()
    },
    { enabled: isAuthenticated },
  )
}
